<template>
  <component
    v-bind="$attrs"
    :is="showComponent"
    :model="model"
    :class="[
      { 'global-card-mixer__list': !isBanner && typeStyle === 'list' },
      { 'global-card-mixer__tile': !isBanner && typeStyle === 'tile' },
      { 'banner-card-mixer__tile': isBanner && typeStyle === 'tile' },
    ]"
  >
  </component>
</template>
<script setup lang="ts">
import cardModelTile from '~/components/product-card/productCardTileModel/productCardTileModel.vue';
import cardOfferTile from '~/components/product-card/productCardTileOffer/productCardTileOffer.vue';
import cardDeModelTile from '~/components/product-card/productCardTileDeModel/productCardTileDeModel.vue';
import cardListDeModel from '~/components/product-card/productCardListDeModel/productCardListDeModel.vue';
import cardOfferList from '~/components/product-card/productCardListOffer/productCardListOffer.vue';
import cardModelList from '~/components/product-card/productCardListModel/productCardListModel.vue';
import cardBanner from '~/components/banners-card/bannersCard.vue';

const props = defineProps({
  typeStyle: {
    type: String,
    default: 'tile',
    validator: (value: string) => ['tile', 'list', 'banner'].includes(value),
  },
  type: {
    type: String as () =>
      | 'offer'
      | 'model'
      | 'deModel'
      | 'retail'
      | 'price-banner',
    default: 'model',
  },
  model: {
    type: Object as () => any,
  },
});

const resultCardList = {
  offer: cardOfferList,
  model: cardModelList,
  deModel: cardListDeModel,
};
const resultCardTile = {
  offer: cardOfferTile,
  model: cardModelTile,
  deModel: cardDeModelTile,
};
const isBanner = computed(() => {
  return props.type === 'retail' || props.type === 'price-banner';
});
const showComponent = computed(() => {
  if (isBanner.value) return cardBanner;
  const isDeModel = props.type === 'offer' && !!props.model?.model_info?.name;
  if (isDeModel)
    return props.typeStyle === 'tile'
      ? resultCardTile.deModel
      : resultCardList.deModel;
  if (
    props.type === 'model' ||
    props.type === 'deModel' ||
    props.type === 'offer'
  ) {
    if (props.typeStyle === 'list') return resultCardList[props.type];
    if (props.typeStyle === 'tile') return resultCardTile[props.type];
  }
  return cardBanner;
});
</script>

<style scoped lang="scss">
.global-card-mixer__tile {
  margin-left: 0;
  margin-right: 4px;
  @include col();
  @include size(12);
  @include size-es(12);
  @include size-sm(8);
  @include size-md(8);
  @include size-lg(8);
  @include size-xl(6);
  @include size-xxl(6);
}

.global-card-mixer__tile {
  &.not-last-in-line {
    margin-left: 0;
    margin-right: 8px;
    @include sm-block {
      margin-right: 12px;
    }
    @include lg-block {
      margin-right: 16px;
    }
  }

  &.last-in-line {
    margin-left: 0;
    margin-right: 0;
  }
}

//.banners-card-wrapper,
.global-card-mixer__tile {
  margin-bottom: 20px;
  @include lg-block {
    margin-bottom: 32px;
  }
}
</style>
